import { render, staticRenderFns } from "./createOrderV2.vue?vue&type=template&id=dfb55a44&scoped=true"
import script from "./createOrderV2.vue?vue&type=script&lang=js"
export * from "./createOrderV2.vue?vue&type=script&lang=js"
import style0 from "./createOrderV2.vue?vue&type=style&index=0&id=dfb55a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb55a44",
  null
  
)

export default component.exports